
import jwtDecode from 'jwt-decode';
const TOKEN_KEY = 'token';

type DecodedToken = {
    id: string;
    type: 'admin' | 'faculty' | 'student' | string;
    user: string;
    iat: number;
    exp: number;
};

export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const decodeToken = (): DecodedToken | null => {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    console.error('Invalid JWT', error);
    return null;
  }
};

export const getUserType = (): string => {
  const decoded = decodeToken();
  return decoded?.type || 'unknown';
};

export const isUserLoggedIn = (): boolean => {
  const token = getToken();
  const decoded = decodeToken();
  if (!token || !decoded?.exp) return false;

  const now = Date.now() / 1000;
  return decoded.exp > now;
};

export const isTokenValid = (): boolean => isUserLoggedIn();

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const isAdmin = (): boolean => {
    const type = decodeToken()?.type;
    return type?.toLowerCase() === 'admin';
  };

  export const hasRole = (role: string): boolean => {
    const type = decodeToken()?.type;
    return type?.toLowerCase() === role.toLowerCase();
  };
  